import React from 'react';
import {FilemanagerApi, getRequest, saveRequest} from '@requests';
import {loadingApplication, addNotification, resendZajavlsIfExistsNotification} from '@componentDP/js_react/redux/actions/application';
import {isEmpty} from 'lodash';
import {filesInfoReceived} from '@componentDP/js_react/redux/actions/files';
import {mappingProfleBasic} from '@helpers/mapping_fields';
import {
    LOADED_PROFILE_BASIC,
    LOADING_PROFILE_BASIC,
    MAILING_REGION,
    MAILING_TOWN_TYPE,
    PROFILE_BASIC,
} from '../store/actionTypes';

export function initializationBasic() {
    return (dispatch, getState) => {
        const {loadedProfileBasic, apiDomainVikon, apiDomainFilemanager} = getState();
        if (!loadedProfileBasic) {
            dispatch(setLoadingProfileBasic(true));
            const chainPromises = [
                getRequest(`${apiDomainVikon}api/digital_profile/applicant`),
                getRequest(`${apiDomainVikon}api/digital_profile/spr/regions`),
                getRequest(`${apiDomainVikon}api/digital_profile/spr/town_types`),
            ];
            Promise.all(chainPromises).then(async (values) => {
                const [profileBasic, mailingRegion, mailingTownType] = values;
                if (!profileBasic.errors) {
                    dispatch(setProfileBasic(profileBasic));
                    const fileIds = [];
                    if (profileBasic.photo_file_id) {
                        fileIds.push(profileBasic.photo_file_id);
                    }
                    if (profileBasic.scan_copy_snils_file_id) {
                        fileIds.push(profileBasic.scan_copy_snils_file_id);
                    }
                    if (!isEmpty(fileIds)) {
                        const filemanagerApi = new FilemanagerApi(apiDomainFilemanager);
                        const result = await filemanagerApi.getFilesInfo(fileIds);
                        dispatch(filesInfoReceived(result));
                    }
                }
                if (!mailingRegion.errors) {
                    dispatch(setMailingRegion(mailingRegion));
                }
                if (!mailingTownType.errors) {
                    dispatch(setMailingTownType(mailingTownType));
                }
                dispatch(setLoadingProfileBasic(false));
                dispatch(setLoadedProfileBasic(true));
            });
        }
    };
}

export function saveBasic(data, successCallback, t) {
    return async (dispatch, getState) => {
        dispatch(loadingApplication(true));
        const {apiDomainVikon} = getState();
        const savedProfileBasic = await saveRequest(`${apiDomainVikon}api/digital_profile/applicant`, data);
        if (!savedProfileBasic.errors) {
            dispatch(setProfileBasic(savedProfileBasic));
            dispatch(addNotification({message: t('saved'), type: 'success'}));
            dispatch(resendZajavlsIfExistsNotification());
            if (successCallback !== undefined) {
                successCallback();
            }
        } else {
            dispatch(addNotification({message: savedProfileBasic.errors, type: 'error'}));
        }
        dispatch(loadingApplication(false));
    };
}
export function setProfileBasic(object) {
    object = mappingProfleBasic(object);
    return {
        type: PROFILE_BASIC,
        object,
    };
}
export function setMailingRegion(list) {
    return {
        type: MAILING_REGION,
        list,
    };
}
export function setMailingTownType(list) {
    return {
        type: MAILING_TOWN_TYPE,
        list,
    };
}
export function setLoadingProfileBasic(status) {
    return {
        type: LOADING_PROFILE_BASIC,
        status,
    };
}
export function setLoadedProfileBasic(status) {
    return {
        type: LOADED_PROFILE_BASIC,
        status,
    };
}
